import { render } from "./ModalPro.vue?vue&type=template&id=12c09609&scoped=true"
import script from "./ModalPro.vue?vue&type=script&lang=js"
export * from "./ModalPro.vue?vue&type=script&lang=js"

import "./ModalPro.vue?vue&type=style&index=0&id=12c09609&scoped=true&lang=scss"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_ORTHO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c09609"]])

export default __exports__